<template lang="pug">
  section
    b-container
      h1 Artists
      b-form-group(label="SHOW")
        b-form-checkbox-group(:options="statusOptions", v-model="filter.status", switches, @input="getArtists()")
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="artists && artists.length > 0")
        p(v-if='artists.length < 1') No artists
        b-table(v-else="", hover, :items="artists", :fields="fields", @row-clicked="openRow", sort-icon-left, sort-by="status_id", :sort-desc="false", responsive, borderless)
          template(v-slot:cell(compName)="row")
            span {{ `${row.item.firstname} ${row.item.lastname}` }}
            b-badge.ml-2(v-if="row.item.is_away") Away
          template(v-slot:cell(compIsFeatured)="row")
            b-form-checkbox(@click.native.stop='', v-model="row.item.is_featured", no-border, @change="setIsFeatured(row.item)")
             span.ml-2 {{ row.item.is_featured ? 'Yes' : 'No' }}
          template(v-slot:cell(compStatus)="row")
            b-badge(:variant="row.item.status === 'pending' ? 'dark' : 'light'") {{ row.item.status }}
      p(v-else="") No artists available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import Vue from 'vue';

export default {
  name: 'Artist',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      artists: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        // { key: 'base', label: 'Based' },
        { key: 'art_count', label: 'Art', sortable: true },
        // { key: 'art_sold', label: 'Sold', sortable: true },
        { key: 'compIsFeatured', label: 'Featured', sortable: true },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
      statusOptions: ['pending', 'active'],
      filter: {
        status: ['pending'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.artists.length;
    },
    artistsPending() {
      return this.artists.filter(item => item.status === 'pending');
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'Artist', params: { artistId: row.id } });
    },
    async getArtists() {
      this.loading();
      this.artists = await apiService.getArtists(this.filter);
      this.clear();
    },
    async setIsFeatured(artist) {
      console.log('Setting featured artist');

      try {
        await apiService.toggleFeaturedArtist(artist.id);
        const newArtist = { ...artist };
        newArtist.is_featured = artist.is_featured;
        const index = this.artists.findIndex(item => item.id === artist.id);
        Vue.set(this.artists, index, newArtist);
      } catch (error) {
        this.error('Could not update featured artists');
      }
    },
  },
  async created() {
    await this.getArtists();
  },
};
</script>

<style lang="scss" scoped>
  .table-responsive {
    margin-bottom: 0;
  }

  .card-body {
    padding: 0;
  }

  .logo {
    width: 200px;
    max-height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Artists.vue